module.exports = __webpack_public_path__ + "static/media/Black-rumped Flameback.3208bf61.png";